import React from 'react'
import TextInput from 'components/ui/forms/field/text-input/TextInput'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import TextAreaInput from 'components/ui/forms/field/text-area/TextArea'
import styles from './EvaluationDetails.module.scss'
import { EditEvaluation } from 'models/evaluation.model'

interface IEvaluationDetails {
  onEditingData: IDetailsData
  onChange: (details: EditEvaluation['details']) => void
}

export interface IDetailsData {
  name: string
  description: string
}

const EvaluationDetails: React.FC<IEvaluationDetails> = ({
  onEditingData,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div id="evaluation-details" className={styles.content}>
      <Row>
        <h1 className={styles.title}>
          {t('administration.blocks.type.evaluation.titles.evaluationDetails')}
        </h1>
      </Row>
      <Row>
        <Col xs={6} className={'p-0 pt-3'}>
          <TextInput
            name={'name'}
            value={onEditingData['name']}
            label={t('administration.blocks.type.evaluation.title')}
            placeHolder={''}
            onChange={(e) =>
              onChange({ ...onEditingData, ['name']: e.target.value })
            }
            disabled={false}
            error={''}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className={'p-0 pt-3'}>
          <TextAreaInput
            name={'description'}
            rows={8}
            label={t('administration.blocks.type.evaluation.description')}
            value={onEditingData['description']}
            onChange={(e) =>
              onChange({ ...onEditingData, ['description']: e.target.value })
            }
            error={''}
          />
        </Col>
      </Row>
    </div>
  )
}

export default EvaluationDetails
